module.exports = __webpack_public_path__ + "static/media/blog_2.d24cd0f7.jpg";